export const market = "mobility";
export const pathname = `/${market}`;

export enum Brand {
	DBA = "DBA",
	FINN = "FINN",
	BLOCKET = "BLOCKET",
}

export enum Locale {
	NB = "nb",
	DA = "da",
	SV = "sv",
	EN = "en",
}

export enum RecEndpoint {
	Car = "car",
	Mc = "mc",
	B2B = "b2b",
	Boat = "boat",
}

export enum MLTEndpoint {
	Car = "car",
	Mc = "mc",
	Boat = "boat",
	Caravan = "caravan",
	MobileHome = "mobile-home",
	CarDealer = "car-dealer",
	B2B = "b2b",
}

export enum AdViewType {
	CarUsed = "car-used",
	CarNew = "car-new",
	CarUsedBusiness = "car-used-business",
	CarLeasing = "car-leasing",
	CarLeasingBusiness = "car-leasing-business",
	CarDealer = "car-dealer",
	Caravan = "caravan",
	MobileHome = "mobile-home",
	Motorcycle = "motorcycle",
	Moped = "moped",
	Snowmobile = "snowmobile",
	ATV = "atv",
	BoatNewSale = "boat-new-sale",
	BoatSale = "boat-sale",
	BoatWanted = "boat-wanted",
	BoatRent = "boat-rent",
	BoatMotor = "boat-motor",
	Truck = "truck",
	Construction = "construction",
	Bus = "bus",
	AgriTractor = "agriculture-tractor",
	AgriThresher = "agriculture-thresher",
	AgriTools = "agriculture-tools",
}
